import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(
  () => ({
    button: {
      minWidth: "auto",
      padding: 0,
      textTransform: "capitalize",
      "&:hover": {
        backgroundColor: "transparent",
      },
    },
    wrapper: {
      whiteSpace: "nowrap",
    },
  }),
  { name: "ReadMore" },
);
